import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DocumentShare, DocumentShareCreate, DocumentShareFilter } from '../data/documentShare';

export function createDocumentShareService(client: AxiosInstance) {
  return createCrudService<DocumentShare, DocumentShareCreate, DocumentShareFilter>(
    client,
    '/document-management/DocumentShare',
    'id',
  );
}

export type DocumentShareService = CrudService<DocumentShare, DocumentShareCreate, DocumentShareFilter>;
